import { createSelector } from '@reduxjs/toolkit';
import { RootSelector, getStore } from '../../models/rootSelector';
import { AutoConflictResolution, ConflictResolverShape } from './model';

export const getConflictResolver: RootSelector<ConflictResolverShape> = createSelector(
  getStore,
  (root) => root.conflictResolver,
);
export const getConflictResolution: RootSelector<AutoConflictResolution> = createSelector(
  getConflictResolver,
  (resolver) => resolver.autoResolve,
);
export const getCurrentFilename: RootSelector<string | null> = createSelector(
  getConflictResolver,
  (resolver) => resolver.currentFileName,
);
export const getIsResolverLocked: RootSelector<boolean> = createSelector(
  getCurrentFilename,
  (fn) => fn !== null,
);
